import { render, staticRenderFns } from "./QrData.vue?vue&type=template&id=2afa874b"
import script from "./QrData.vue?vue&type=script&lang=js"
export * from "./QrData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports